import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { AnomalyState, SelectionForDetailTable } from "./anomalyTypes";
import {
  CellValueDto,
  PostAnomalyGetTableApiArg,
  PostAnomalyGetTableApiResponse,
  anomalyApi,
} from "../../../app/apislices/anomalyApi";
import { GridSortModel, GridFilterModel } from "@mui/x-data-grid-premium";

const initialState: AnomalyState = {
  selectedStart: dayjs().add(-8, "days").toISOString(),
  selectedEnd: dayjs().add(-1, "days").toISOString(),
  selectionForDetailTable: null,
  sortModel: [{ field: "day", sort: "desc" }],
  filterModel: { items: [] },
  showOverview: true,
  showParameterPanel: true,
  isSubmitted: false,
};

const anomalySlice = createSlice({
  name: "anomalySlice",
  initialState,
  reducers: {
    setSelectionForDetailTable: (state, action: PayloadAction<SelectionForDetailTable | null>) => {
      state.selectionForDetailTable = action.payload;
    },
    setSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.sortModel = action.payload;
    },
    setFilterModel: (state, action: PayloadAction<GridFilterModel>) => {
      state.filterModel = action.payload;
    },
    setShowOverview: (state, action: PayloadAction<boolean>) => {
      state.showOverview = action.payload;
    },
    setShowParameterPanel: (state, action: PayloadAction<boolean>) => {
      state.showParameterPanel = action.payload;
    },
    setIsSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isSubmitted = action.payload;
    },
    setSelectedStart: (state, action: PayloadAction<string>) => {
      state.selectedStart = action.payload;
    },
    setSelectedEnd: (state, action: PayloadAction<string>) => {
      state.selectedEnd = action.payload;
    },
  },
});

export const {
  setSelectionForDetailTable,
  setSortModel,
  setFilterModel,
  setShowOverview,
  setShowParameterPanel,
  setIsSubmitted,
  setSelectedStart,
  setSelectedEnd,
} = anomalySlice.actions;

export default anomalySlice.reducer;

anomalyApi.enhanceEndpoints({
  endpoints: {
    postAnomalyGetTable: {
      transformResponse: (response: PostAnomalyGetTableApiResponse, meta: unknown, args: PostAnomalyGetTableApiArg) => {
        if (response.length === 0) return response;
        let columnHeaders = response.flatMap((row) => row.map((col) => col.col));
        columnHeaders = [...new Set(columnHeaders)];
        return response
          .map((row) =>
            [
              ...row,
              ...columnHeaders
                .filter((columnHeader) => !row.find((x) => x.col === columnHeader))
                .map((x) => (({
                row: row[0].row,
                col: x,
                value: null
              }) as CellValueDto)),
            ].sort((a, b) => a.col.localeCompare(b.col))
          )
          .sort((a, b) => a[0].row.localeCompare(b[0].row));
      },
    },
  },
});
